import { render } from "./CreateProductModal.vue?vue&type=template&id=6496c0c7&scoped=true"
import script from "./CreateProductModal.vue?vue&type=script&lang=js"
export * from "./CreateProductModal.vue?vue&type=script&lang=js"

import "./CreateProductModal.vue?vue&type=style&index=0&id=6496c0c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6496c0c7"]])

export default __exports__